import { SVGProps } from "react";
const EditPostSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props} viewBox="0 0 16 16">
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m3.528 10.413 6.884-6.884c.26-.26.682-.26.942 0l1.118 1.117c.26.26.26.682 0 .942l-6.885 6.884a.663.663 0 0 1-.47.195H3.332v-1.783c0-.177.07-.346.195-.471Z"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m9.167 4.773 2.06 2.06"
    />
  </svg>
);
export default EditPostSvg;
